module.exports = __webpack_public_path__ + "static/pubnub-06a6bdf7e728ae0d8ecda411784f5546.png";